// extracted by mini-css-extract-plugin
export default {"uploadButton":"frontend-common-libs-src-components-common-dialogs-styles-OpenFileDialogButton-module__uploadButton--WisFQR1pWz7QGl+oXrFS7g=="};